<div class="field-time-wrap">
  <mat-form-field class="field-time" appearance="outline">
      <!--<mat-label>{{ fieldLabel }} time</mat-label>-->
      <mat-select disabled={{readOnly}} [value]="timeValue" (selectionChange)="onTimeChange($event)">
          <mat-option *ngFor="let timeValue of timeValueList" [value]="timeValue">{{ timeValue }}</mat-option>
      </mat-select>
  </mat-form-field>
</div>
